import { render, staticRenderFns } from "./FlashPromoProducts.vue?vue&type=template&id=84799a3c"
import script from "./FlashPromoProducts.vue?vue&type=script&lang=js"
export * from "./FlashPromoProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports